var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_556_176212)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#F4F6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1318 50.8488C57.183 44.5128 84.1398 15.828 96.1278 38.7096C106.16 57.8568 83.9718 75.8184 70.6878 82.3896C53.4078 90.9408 28.0086 87.564 14.3358 71.4C8.45582 64.44 6.33421 54.6 16.5918 52.7688C20.0526 52.1496 25.9278 54.4056 29.8398 54.2088C34.8534 53.9568 39.7638 52.968 44.1318 50.8488Z",
    fill: "#61F3F3",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4783 37.3632C50.9479 38.652 47.8255 38.5656 44.5519 37.2144C41.2783 35.8632 39.0559 33.7248 39.5887 32.4384C39.7111 32.1408 40.0543 31.0248 40.4239 30.8688C41.6431 30.3552 43.9639 31.512 46.4767 32.5488C48.8167 33.5136 51.4903 34.1352 51.9055 35.4048C52.1599 36.18 51.6295 36.996 51.4783 37.3632Z",
    fill: "#0ABAB5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M51.9075 35.4072C52.1067 36.4176 51.6675 36.9024 51.4779 37.3632C51.2811 37.8384 50.7339 38.1264 49.9587 38.232C49.8651 38.2464 49.7667 38.256 49.6659 38.2632C49.1451 38.3016 48.5427 38.2704 47.8851 38.1696C47.8011 38.16 47.7171 38.1432 47.6307 38.1288C46.9875 38.0184 46.3011 37.8408 45.5931 37.6056C45.5163 37.5792 45.4395 37.5528 45.3627 37.524C45.0939 37.4304 44.8203 37.3272 44.5491 37.2144C44.2779 37.104 44.0139 36.984 43.7571 36.8616C43.6827 36.828 43.6107 36.792 43.5387 36.756C42.8931 36.4368 42.3075 36.0888 41.7939 35.7336C41.7267 35.688 41.6619 35.64 41.5971 35.5968C41.0595 35.2056 40.6083 34.8048 40.2675 34.4088C40.2075 34.3416 40.1547 34.2768 40.1019 34.2096C39.5859 33.5544 39.3819 32.9328 39.5859 32.436C39.7179 32.1144 40.0083 31.0224 40.4187 30.8664C40.8291 30.7128 41.3595 30.7344 41.9739 30.864C42.0531 30.8808 42.1347 30.9 42.2163 30.9216C43.4283 31.2288 44.9283 31.9128 46.4715 32.5488C48.2931 33.3 50.4459 34.08 51.4995 34.98C51.5643 35.0352 51.6243 35.0904 51.6795 35.148C51.7707 35.2344 51.8427 35.3208 51.9075 35.4072Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.3303 30.7224L42.2199 30.924L40.2711 34.4112C40.2111 34.344 40.1583 34.2792 40.1055 34.212L41.9775 30.8664L42.1215 30.6072L42.3303 30.7224Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8052 32.1432L41.7964 35.736C41.7292 35.6904 41.6644 35.6424 41.5996 35.5992L43.5964 32.0256L43.8052 32.1432Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4984 34.2073L45.5976 37.6081C45.5208 37.5817 45.444 37.5553 45.3672 37.5265L47.2896 34.0897L47.4984 34.2073Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7802 33.2472L43.7594 36.864C43.685 36.8304 43.613 36.7944 43.541 36.7584L45.569 33.1296L45.7802 33.2472Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.7376 34.8649L47.8872 38.1721C47.8032 38.1625 47.7192 38.1457 47.6328 38.1313L49.5264 34.7449L49.7376 34.8649Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.0041 36.1165C48.2769 37.4664 51.3605 37.5168 51.8917 36.2291C52.4229 34.9413 50.2004 32.803 46.9277 31.4531C43.655 30.1031 40.5713 30.0527 40.0402 31.3405C39.509 32.6283 41.7314 34.7665 45.0041 36.1165Z",
    fill: "#0ABAB5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M45.4083 35.4831C47.9985 36.5515 50.4027 36.6796 50.7783 35.7692C51.1538 34.8588 49.3584 33.2547 46.7682 32.1863C44.1779 31.1178 41.7737 30.9897 41.3982 31.9001C41.0227 32.8105 42.8181 34.4146 45.4083 35.4831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.018 25.7136C68.87 26.8152 67.2428 29.4792 64.4444 31.6488C61.646 33.816 58.6844 34.68 57.8324 33.5784C57.6356 33.324 56.8388 32.4696 56.8868 32.0736C57.0476 30.7608 59.2052 29.3232 61.3556 27.6576C63.3572 26.1072 65.2244 24.096 66.5348 24.3672C67.3292 24.5352 67.7756 25.4016 68.018 25.7136Z",
    fill: "#0ABAB5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.5352 24.3696C67.512 24.7008 67.7136 25.32 68.0184 25.7136C68.3328 26.1192 68.3112 26.7384 68.0184 27.4632C67.9848 27.552 67.944 27.6408 67.9008 27.732C67.6752 28.2024 67.3488 28.7112 66.936 29.2296C66.8856 29.2968 66.8304 29.3616 66.7752 29.4288C66.36 29.9304 65.8656 30.4392 65.3064 30.936C65.2464 30.9888 65.184 31.0416 65.1216 31.0968C64.9056 31.2816 64.6824 31.4688 64.4472 31.6488C64.2168 31.8288 63.9816 31.9992 63.7464 32.16C63.6792 32.208 63.612 32.2512 63.5472 32.2968C62.9496 32.6976 62.3568 33.0336 61.7904 33.3024C61.716 33.3384 61.644 33.3696 61.572 33.4032C60.9672 33.6744 60.3912 33.8664 59.8824 33.9672C59.796 33.9864 59.712 34.0008 59.628 34.0128C58.8024 34.1352 58.1616 34.0032 57.8328 33.5784C57.6192 33.3048 56.8176 32.5104 56.8848 32.076C56.9544 31.6416 57.2376 31.1928 57.6552 30.7272C57.7104 30.6672 57.7656 30.6048 57.8256 30.5448C58.6944 29.6472 60.0336 28.6848 61.3536 27.6624C62.9112 26.4576 64.6584 24.9768 65.964 24.5088C66.0432 24.4776 66.1224 24.456 66.1992 24.4344C66.3192 24.4032 66.4272 24.3816 66.5352 24.3696Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7084 30.3456L57.826 30.5424L59.8804 33.9672C59.794 33.9864 59.71 34.0008 59.626 34.0128L57.6556 30.7248L57.502 30.4704L57.7084 30.3456Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.6736 29.7745L61.7904 33.3025C61.716 33.3385 61.644 33.3697 61.572 33.4033L59.4648 29.8945L59.6736 29.7745Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3001 27.5977L65.3041 30.9385C65.2441 30.9913 65.1817 31.0441 65.1193 31.0993L63.0938 27.7225L63.3001 27.5977Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6146 28.6105L63.7458 32.1625C63.6786 32.2105 63.6114 32.2537 63.5466 32.2993L61.4082 28.7353L61.6146 28.6105Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.9857 25.98L66.9345 29.232C66.8841 29.2992 66.8289 29.364 66.7737 29.4312L64.7793 26.1048L64.9857 25.98Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.7175 30.7101C66.5166 28.5423 68.0941 25.8921 67.2411 24.7908C66.3882 23.6894 63.4276 24.5539 60.6286 26.7216C57.8296 28.8894 56.252 31.5396 57.105 32.6409C57.958 33.7423 60.9185 32.8778 63.7175 30.7101Z",
    fill: "#0ABAB5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.3707 30.0437C65.586 28.3279 66.893 26.3059 66.29 25.5273C65.687 24.7487 63.4023 25.5084 61.187 27.2241C58.9717 28.9398 57.6646 30.9618 58.2676 31.7404C58.8706 32.519 61.1554 31.7594 63.3707 30.0437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4334 20.5536C56.1526 22.1328 52.6198 22.8024 48.6046 22.0896C44.5894 21.3768 41.5654 19.5144 41.8462 17.9352C41.911 17.568 42.0238 16.2312 42.4006 15.9648C43.6462 15.0864 46.5406 15.8184 49.6246 16.368C52.495 16.8792 55.6558 16.92 56.4358 18.2472C56.9062 19.0536 56.5126 20.1024 56.4334 20.5536Z",
    fill: "#0ABAB5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M56.4334 18.2472C56.9062 19.3344 56.5318 19.9872 56.431 20.5536C56.3278 21.1368 55.783 21.5952 54.9358 21.9048C54.835 21.9456 54.727 21.9792 54.6142 22.0128C54.0382 22.1832 53.3518 22.2984 52.5886 22.3464C52.4902 22.356 52.3942 22.3584 52.2934 22.3632C51.5446 22.3968 50.7286 22.3656 49.8742 22.2744C49.783 22.2648 49.687 22.2528 49.5934 22.2408C49.2694 22.2 48.9358 22.152 48.6022 22.092C48.271 22.0344 47.9446 21.9648 47.6254 21.8904C47.5342 21.8712 47.443 21.8472 47.3542 21.8256C46.5502 21.624 45.8062 21.3792 45.139 21.1032C45.0502 21.0672 44.9686 21.0312 44.8846 20.9976C44.1862 20.6904 43.5766 20.3472 43.0966 19.9896C43.0126 19.9296 42.9358 19.8696 42.8614 19.8072C42.1198 19.1976 41.7382 18.5472 41.8462 17.94C41.9158 17.5464 41.9734 16.2456 42.3982 15.9696C42.823 15.6936 43.4254 15.588 44.1454 15.5856C44.239 15.5856 44.335 15.5856 44.4334 15.5904C45.871 15.6384 47.7286 16.0392 49.6198 16.3752C51.8518 16.7736 54.4654 17.1192 55.8742 17.8752C55.9606 17.9208 56.0422 17.9688 56.119 18.0192C56.2366 18.0864 56.3398 18.1656 56.4334 18.2472Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5101 15.3312L44.4333 15.5832L43.0965 19.9848C43.0125 19.9248 42.9357 19.8648 42.8613 19.8024L44.1453 15.5784L44.2437 15.252L44.5101 15.3312Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5163 16.5672L45.1411 21.1008C45.0523 21.0648 44.9707 21.0288 44.8867 20.9952L46.2547 16.4856L46.5163 16.5672Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1797 17.9808L49.8765 22.2744C49.7853 22.2648 49.6893 22.2528 49.5957 22.2408L50.9133 17.9016L51.1797 17.9808Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0134 17.3232L47.6286 21.888C47.5374 21.8688 47.4462 21.8448 47.3574 21.8232L48.747 17.2416L49.0134 17.3232Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8617 18.168L52.5921 22.344C52.4937 22.3536 52.3977 22.356 52.2969 22.3608L53.5953 18.0864L53.8617 18.168Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.8442 20.7412C52.8582 21.4556 56.3399 20.7546 56.6209 19.1756C56.9019 17.5967 53.8757 15.7376 49.8617 15.0233C45.8477 14.3089 42.366 15.0099 42.085 16.5888C41.804 18.1678 44.8302 20.0269 48.8442 20.7412Z",
    fill: "#0ABAB5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M49.1453 19.9293C52.3215 20.4945 55.0573 20.0483 55.2559 18.9326C55.4544 17.8168 53.0406 16.4542 49.8643 15.8889C46.6881 15.3237 43.9523 15.7699 43.7538 16.8857C43.5552 18.0014 45.9691 19.3641 49.1453 19.9293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3863 60.8712L52.6879 62.3088C51.8119 62.3592 50.9527 62.5704 50.1535 62.928L23.3263 74.9352C22.3519 75.372 21.8143 76.416 22.0327 77.4456L26.4703 98.4072C26.7751 99.8448 28.3783 100.603 29.7103 99.9384L56.1895 86.7192L80.6407 85.8936C81.9247 85.8504 82.8847 84.7008 82.6807 83.4504L79.4071 63.3768C79.2367 62.34 78.4519 60.84 77.3863 60.8712Z",
    fill: "#0ABAB5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M77.3863 60.8712L52.6879 62.3088C51.8119 62.3592 50.9527 62.5704 50.1535 62.928L23.3263 74.9352C22.3519 75.372 21.8143 76.416 22.0327 77.4456L26.4703 98.4072C26.7751 99.8448 28.3783 100.603 29.7103 99.9384L56.1895 86.7192L80.6407 85.8936C81.9247 85.8504 82.8847 84.7008 82.6807 83.4504L79.4071 63.3768C79.2367 62.34 78.4519 60.84 77.3863 60.8712Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8076 47.2256L14.8457 59.1721L38.1027 84.4059L51.0646 72.4594L27.8076 47.2256Z",
    fill: "#0ABAB5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M51.0661 72.456L38.1037 84.4032L14.8477 59.172L23.3533 51.3312L27.8101 47.2224L28.5517 48.0288L51.0661 72.456Z",
    fill: "#61F3F3",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8922 48.7676L16.4551 59.3088L38.2092 82.912L49.6464 72.3708L27.8922 48.7676Z",
    stroke: "#0ABAB5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6222 68.6323C36.934 67.4232 36.7683 65.1094 35.252 63.4642C33.7357 61.819 31.443 61.4655 30.1312 62.6746C28.8193 63.8837 28.9851 66.1975 30.5014 67.8427C32.0176 69.4878 34.3103 69.8414 35.6222 68.6323Z",
    fill: "#0ABAB5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M37.9671 74.1624L33.3615 75.7536L23.3535 51.3312L27.8103 47.2224L28.5519 48.0288L37.9671 74.1624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8611 37.3381L22.2891 43.3457L33.9845 75.6077L50.5566 69.6001L38.8611 37.3381Z",
    fill: "#0ABAB5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M38.8611 37.3381L22.2891 43.3457L33.9845 75.6077L50.5566 69.6001L38.8611 37.3381Z",
    fill: "#61F3F3",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3414 38.7941L23.7188 44.095L34.6584 74.2722L49.2811 68.9713L38.3414 38.7941Z",
    stroke: "#0ABAB5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7943 60.1027C39.4715 59.4947 40.2131 57.2966 39.4505 55.1932C38.688 53.0898 36.7102 51.8776 35.033 52.4856C33.3558 53.0936 32.6142 55.2917 33.3767 57.3951C34.1393 59.4985 36.1171 60.7107 37.7943 60.1027Z",
    fill: "#0ABAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5461 61.7232L53.1861 63.096C52.3221 63.144 51.4749 63.3528 50.6877 63.708L24.2541 75.6408C23.2941 76.0728 22.7661 77.1168 22.9845 78.1464L27.4173 99.1104C27.7221 100.548 29.3061 101.309 30.6189 100.649L56.7069 87.5064L80.8245 86.7432C82.0917 86.7024 83.0349 85.5576 82.8309 84.3072L79.5501 64.236C79.3773 63.1968 78.5973 61.6944 77.5461 61.7232Z",
    fill: "#0ABAB5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.1777 66.768L75.0793 65.4816",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M51.6738 67.308L55.4922 84.8472",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.2148 83.1432L28.9076 96.636C28.9076 96.6336 30.9716 91.2816 26.2148 83.1432Z",
    fill: "#61F3F3",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.5684 83.3016C26.6596 83.5488 50.4844 73.3176 50.4844 73.3176C50.4844 73.3176 51.0868 80.6712 43.918 84.6936C36.7492 88.7136 26.5684 83.3016 26.5684 83.3016Z",
    fill: "#61F3F3",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3933 83.7C42.9633 83.7 43.4253 83.2379 43.4253 82.668C43.4253 82.098 42.9633 81.636 42.3933 81.636C41.8234 81.636 41.3613 82.098 41.3613 82.668C41.3613 83.2379 41.8234 83.7 42.3933 83.7Z",
    fill: "#0ABAB5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.498 73.3176C50.498 73.3176 53.4524 77.7624 52.7372 85.3392L50.498 73.3176Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0742 77.844L25.6238 77.6016",
    stroke: "#61F3F3",
    strokeOpacity: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7637 77.0976L49.0117 67.2624",
    stroke: "#61F3F3",
    strokeOpacity: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5.2 5.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.584 67.0104L50.1312 66.768",
    stroke: "#61F3F3",
    strokeOpacity: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.8789 70.7112L75.7805 69.4224",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.8203 75.6288L76.7219 74.34",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1393 40.6944C72.1393 40.6944 71.6137 46.2936 69.5329 46.776C67.4521 47.2584 65.6953 46.392 65.6953 46.392L64.0033 45.0912L63.1777 47.9688C63.1777 47.9688 64.0801 49.1952 65.9641 48.3456C65.9641 48.3456 69.3217 49.8264 71.1817 48.3456C73.0417 46.8648 73.6345 42.8112 73.6345 42.8112L72.1393 40.6944Z",
    fill: "#FBCDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8117 37.9824C73.8117 37.9824 72.3597 35.508 73.0197 31.0224C73.6797 26.5368 77.4405 25.9752 78.8925 26.304C80.3445 26.6328 81.5325 28.0248 82.5213 30.6768C83.5101 33.3312 83.8749 34.0224 85.5237 33.5616C87.1725 33.1008 91.5597 31.6488 92.7813 32.9352C94.0005 34.2216 93.6069 35.6736 93.6069 35.6736C93.6069 35.6736 99.7101 34.188 99.1821 39.6312C98.6541 45.0744 89.8461 50.1552 81.4677 44.7768C73.0893 39.3984 73.8117 37.9824 73.8117 37.9824Z",
    fill: "#003768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7452 51.156C73.7452 51.156 72.0868 65.4192 72.142 72.1104C72.1972 78.8016 74.5756 94.5576 74.5756 94.5576H77.506C77.506 94.5576 77.1196 81.9528 77.1748 77.64C77.23 73.3272 78.0052 66.1968 78.0052 66.1968C78.0052 66.1968 78.946 72.6096 80.05 74.8776C81.1564 77.1432 87.2932 85.1616 91.5508 87.648L93.5404 85.824C93.5404 85.824 89.1172 80.3496 87.4588 77.6424C85.8004 74.9328 84.3076 74.16 83.698 69.1272C83.0908 64.0968 84.1396 56.0232 82.3708 51.1584H73.7452V51.156Z",
    fill: "#003768"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M78.0021 66.1944L76.7277 57.1536C76.7277 57.1536 75.7221 62.5896 77.7045 69.2256L78.0021 66.1944Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1758 95.3592L75.2742 98.16L77.2398 98.3232L77.3382 98.0616V95.1624L75.1758 95.3592Z",
    fill: "#FBCDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2422 94.2936L74.4222 95.3424L77.7966 95.424L78.0102 94.164L74.2422 94.2936Z",
    fill: "#0ABAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6211 87.84L93.7483 84.9264L94.4371 86.0232L91.7515 88.4808L90.6211 87.84Z",
    fill: "#0ABAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1289 87.84L94.1929 89.5776L95.5177 88.02L93.8233 86.268L92.1289 87.84Z",
    fill: "#FBCDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9193 87.9L97.1673 88.668C97.4097 88.8168 97.4601 89.148 97.2705 89.3616C96.3657 90.3816 94.0545 92.9784 93.8241 93.1632C93.5385 93.3936 93.1929 93 93.1113 92.64C93.1113 92.64 93.7665 91.7712 93.8241 91.2144C93.8673 90.804 93.8457 90.2088 93.8337 89.9232C93.8289 89.8152 93.8649 89.7096 93.9345 89.628L95.3289 87.9936C95.4777 87.8208 95.7273 87.78 95.9193 87.9Z",
    fill: "#003768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7195 98.3952L77.9787 99.8376C78.0291 100.118 77.8155 100.378 77.5299 100.378C76.1643 100.382 72.6891 100.394 72.3987 100.344C72.0363 100.284 72.1011 99.7656 72.3147 99.4632C72.3147 99.4632 73.3995 99.372 73.8507 99.0432C74.1843 98.8008 74.6139 98.388 74.8203 98.1888C74.8971 98.112 75.0003 98.0688 75.1083 98.0664L77.2563 98.016C77.4819 98.0136 77.6787 98.1744 77.7195 98.3952Z",
    fill: "#003768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6829 43.2456L85.6781 41.1432C85.6781 41.1432 84.8813 37.956 83.7029 37.7976C82.5245 37.6392 76.6613 36.5232 72.9317 37.7976C72.9317 37.7976 71.5925 38.1792 71.1797 41.94L72.7733 42.4488C72.7733 42.4488 73.3469 49.4904 73.6973 50.5728H82.2053C82.2053 50.5752 82.3013 44.52 82.6829 43.2456Z",
    fill: "#0ABAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3305 42.792C83.3305 42.792 84.4633 46.032 84.6673 47.7744C84.6673 47.7744 81.9697 46.7016 81.2713 46.2072L80.7457 44.3112L78.9505 43.4496L78.4297 44.8704L79.9081 46.728C79.9081 46.728 83.9689 50.5296 86.0305 49.6584C88.0921 48.7872 85.2145 41.4672 85.2145 41.4672L83.3305 42.792Z",
    fill: "#FBCDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7114 28.6056C75.7114 28.6056 74.6746 30.6816 74.761 32.3664C74.8474 34.0512 75.6898 34.7448 77.3122 34.9824C77.3122 34.9824 78.0034 37.1424 76.189 37.3608C76.0498 37.3776 76.0018 37.9272 76.0138 38.016C76.0618 38.3664 76.4074 38.5584 76.7218 38.64C77.0578 38.7288 77.4154 38.7432 77.7634 38.7552C78.541 38.7816 79.1818 38.4672 79.6978 37.8936C79.7386 37.8504 80.101 37.3824 80.101 37.3824C80.101 37.3824 79.237 36.9528 79.5394 34.14C79.5394 34.14 80.1226 33.816 80.4466 33.0168C80.4466 33.0168 81.0082 32.736 81.1378 32.1744C81.2674 31.6128 80.7706 30.8352 79.8634 31.6128C79.8634 31.6128 78.157 30.7488 77.5066 27.7224C77.5042 27.7176 76.8346 28.476 75.7114 28.6056Z",
    fill: "#FBCDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.197 31.9056L76.3458 30.7968L75.5586 31.6656C75.5586 31.6656 75.8082 31.9536 76.197 31.9056Z",
    fill: "#A24E3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6543 32.7168C76.6543 32.7168 77.4823 32.844 77.8807 32.3112",
    stroke: "#003768",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4824 29.2441C77.4824 29.2441 78.0104 29.0401 78.5552 29.5297",
    stroke: "#003768",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0491 29.004C76.0491 29.004 75.5787 28.9296 75.3555 29.2032",
    stroke: "#003768",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5788 30.9779C77.6905 30.9925 77.7987 30.8689 77.8204 30.702C77.8421 30.535 77.7691 30.3879 77.6574 30.3734C77.5457 30.3589 77.4375 30.4824 77.4158 30.6494C77.3941 30.8163 77.4671 30.9634 77.5788 30.9779Z",
    fill: "#003768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6608 30.6102C75.7725 30.6247 75.8806 30.5012 75.9024 30.3342C75.9241 30.1673 75.8511 30.0202 75.7394 30.0057C75.6277 29.9912 75.5195 30.1147 75.4978 30.2816C75.4761 30.4485 75.549 30.5956 75.6608 30.6102Z",
    fill: "#003768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6546 30.3744L77.2754 30.2088C77.2754 30.2088 77.3522 30.5496 77.6546 30.3744Z",
    fill: "#003768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7737 30.0192L75.3945 29.8536C75.3945 29.8536 75.4737 30.1944 75.7737 30.0192Z",
    fill: "#003768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4023 50.2008V51.2016L82.6183 51.2784L82.3711 50.088L73.4023 50.2008Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M73.4023 50.2008V51.2016L82.6183 51.2784L82.3711 50.088L73.4023 50.2008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5138 45.3432L68.4474 62.976C68.0898 64.2216 67.0122 65.0664 65.8026 65.1864C65.4258 65.2224 65.0346 65.1912 64.6458 65.0808L54.9474 62.2944C53.3178 61.824 52.3746 60.1224 52.8426 58.4928L57.9114 40.8576C58.185 39.9144 58.8666 39.2016 59.7138 38.8584C60.3258 38.6088 61.0266 38.556 61.713 38.7552L71.409 41.5392C73.041 42.0072 73.9818 43.7088 73.5138 45.3432Z",
    fill: "#0ABAB5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M73.5138 45.3432L68.4474 62.976C68.0898 64.2216 67.0122 65.0664 65.8026 65.1864C65.4258 65.2224 65.0346 65.1912 64.6458 65.0808L54.9474 62.2944C53.3178 61.824 52.3746 60.1224 52.8426 58.4928L57.9114 40.8576C58.185 39.9144 58.8666 39.2016 59.7138 38.8584C60.3258 38.6088 61.0266 38.556 61.713 38.7552L71.409 41.5392C73.041 42.0072 73.9818 43.7088 73.5138 45.3432Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6694 45.552L67.603 63.1848C67.3318 64.1304 66.6454 64.8456 65.8006 65.1864C65.4238 65.2224 65.0326 65.1912 64.6438 65.0808L54.9454 62.2944C53.3158 61.824 52.3726 60.1224 52.8406 58.4928L57.9094 40.8576C58.183 39.9144 58.8646 39.2016 59.7118 38.8584C60.0886 38.8224 60.4798 38.8536 60.8686 38.964L70.5646 41.748C72.1966 42.2184 73.1398 43.92 72.6694 45.552Z",
    fill: "#0ABAB5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M72.6694 45.552L67.603 63.1848C67.3318 64.1304 66.6454 64.8456 65.8006 65.1864C65.4238 65.2224 65.0326 65.1912 64.6438 65.0808L54.9454 62.2944C53.3158 61.824 52.3726 60.1224 52.8406 58.4928L57.9094 40.8576C58.183 39.9144 58.8646 39.2016 59.7118 38.8584C60.0886 38.8224 60.4798 38.8536 60.8686 38.964L70.5646 41.748C72.1966 42.2184 73.1398 43.92 72.6694 45.552Z",
    fill: "#61F3F3",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.045 47.0482L58.0078 46.756L54.2757 60.0015L55.3129 60.2938L59.045 47.0482Z",
    fill: "#61F3F3",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8005 60.7176L55.7637 60.4176L59.4957 47.1768L60.5301 47.4744L56.8005 60.7176Z",
    fill: "#61F3F3",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3083 61.1495L57.2715 60.8519L61.0035 47.6111L62.0403 47.9087L58.3083 61.1495Z",
    fill: "#61F3F3",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M68.0783 49.6455L67.041 49.3534L63.3102 62.6003L64.3475 62.8924L68.0783 49.6455Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.943 45.8999L67.427 47.6976L66.8126 47.5248C66.1934 47.3496 65.8334 46.7063 66.0062 46.0871L66.3422 44.8943L67.583 45.2495C67.8614 45.3311 68.0222 45.6215 67.943 45.8999Z",
    fill: "#61F3F3",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.649 45.0192L66.4082 44.664L66.7802 43.3488C66.953 42.7296 67.5986 42.3696 68.2178 42.5424L68.8562 42.7224L68.2994 44.6592C68.2202 44.94 67.9298 45.1008 67.649 45.0192Z",
    fill: "#61F3F3",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8246 45.6072L70.0726 45.9648L69.7414 47.1384C69.5686 47.7576 68.9254 48.12 68.3062 47.9448L67.6582 47.7624L68.1742 45.9672C68.2534 45.6888 68.5438 45.528 68.8246 45.6072Z",
    fill: "#61F3F3",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5148 44.4L70.138 45.7344L68.89 45.3768C68.6116 45.2952 68.4508 45.0048 68.53 44.7264L69.0868 42.7896L69.7084 42.9648C70.3276 43.1376 70.6876 43.7808 70.5148 44.4Z",
    fill: "#61F3F3",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_556_176212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet1);
export default __webpack_public_path__ + "static/media/wallet-1.29ddf415e012a742e769025a8378beae.svg";
export { ForwardRef as ReactComponent };